<div class="row">
  <div class="col-12">
    <nz-result nzStatus="warning" nzTitle="Acesso não permitido!" nzSubTitle="Desculpe, você não está autorizado a acessar esta página.">
      <div nz-result-extra class="d-flex justify-content-center">
        <button nz-button nzType="primary" nzSize="large" (click)="back()">Voltar para Dashboard</button>
      </div>
    </nz-result>
  </div>
</div>
